import React from 'react';
import PropTypes from 'prop-types';
import { useTranslations } from '@unisporkal/localization';
import { useSiteMap } from '@unisporkal/sites';
import { RawHtml } from '@unisporkal/utilities';
import { List, ListItem } from '@unisporkal/alliance-ui';
import styles from './AssetRestrictions.module.scss';

const AssetRestrictions = ({ restrictions }) => {
  const t = useTranslations();
  const siteMap = useSiteMap();

  const replacePipesWithLink = (match, p1) =>
    `<a className=${
      styles.link
    } href=${siteMap.contact()} target="_blank" rel="noopener noreferrer">${p1}</a>`;

  const renderRestrictions = () =>
    restrictions.map((restriction) => {
      if (!restriction?.reason) {
        return null;
      }
      const restrictionWithoutPipes = restriction.reason.replace(
        /\|(.*?)\|/g,
        replacePipesWithLink
      );
      return (
        <ListItem key={`${restriction.assetId}-${restriction.reason}`}>
          <RawHtml>
            {`${restriction.assetId} - ${restrictionWithoutPipes}`}
          </RawHtml>
        </ListItem>
      );
    });

  return (
    <section data-testid="asset-restrictions">
      <div className={styles.ezaRestrictions}>{t('eza_restrictions_info')}</div>
      <List>{renderRestrictions()}</List>
    </section>
  );
};

AssetRestrictions.propTypes = {
  restrictions: PropTypes.arrayOf(
    PropTypes.shape({ asset_id: PropTypes.string, reason: PropTypes.string })
  ).isRequired,
};

export default AssetRestrictions;
